import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceAllocateResourcesNotificationState = createStateReducer(
  initialState,
  {
    [events.allocateResourcesSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "allocateResources",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.allocateResourcesFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "allocateResources",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAllocateResourcesNotificationState };
